import { render, staticRenderFns } from "./SiteContent.vue?vue&type=template&id=94bba226&scoped=true"
import script from "./SiteContent.vue?vue&type=script&lang=js"
export * from "./SiteContent.vue?vue&type=script&lang=js"
import style0 from "./SiteContent.vue?vue&type=style&index=0&id=94bba226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bba226",
  null
  
)

export default component.exports